import React, { useState } from "react";
import { Checkbox, Dropdown, Image, Tooltip } from "antd";
import { FileImageOutlined, FileTextOutlined, MoreOutlined } from "@ant-design/icons";
import moment from "moment";
import { FaRegFilePdf } from "react-icons/fa";
import { conterOfferContractTypes, createOfferContractTypes, listingContractTypes } from "../../Common/commondata/commonData";
import { hasPropertyDocsMenuItems } from "../../CreateOffer/features/helperFunctions";
import ProperyDocMenuItem from "./PropertyDocMenuItem";
// import ProperyDocMenuItem from "./ProperyDocMenuItem";
// import { hasPropertyDocsMenuItems } from "../utils/helper";
import ResureSign from "../../Assets/Icons/Resure_icon.png";
import styles1 from "../style/RtdWindow.module.css";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import { formatBaseName } from "../../Common/utils/universalFuntions";

const PropertyDocFile = ({ ele, role, item, handlePropertyDocs, handleShareUnshareFileConfirm, handleToggleDashboard, handleDeletePropertyDocs, isSmallScreen, handleDragStart, selectedFiles, setSelectedFiles, handleCreateAmendExtend, handleEditName }) => {
  const [hoveredRow, setHoveredRow] = useState(null);

  const ellispesStyle = {
    maxWidth: "330px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
  }

  const handleSelectFile = (fileId, contractId,resureSignDoc) => {
    if(resureSignDoc){
      let  updatedResureSignDocs = selectedFiles?.resureSignDocs?.filter((el) => el?.resureSignDocId === fileId)?.length ? selectedFiles?.resureSignDocs?.filter((el) => el?.resureSignDocId !== fileId) : [...selectedFiles?.resureSignDocs, { resureSignDocId: fileId, selectedParentId: null }];
      setSelectedFiles({ ...selectedFiles, resureSignDocs:  updatedResureSignDocs });
    }
    else if (contractId) {
      let updatedOfferDocs = selectedFiles?.offerDocs?.filter((el) => el?.offerDocId === fileId)?.length ? selectedFiles?.offerDocs?.filter((el) => el?.offerDocId !== fileId) : [...selectedFiles?.offerDocs, { offerDocId: fileId, selectedParentId: null }];
      setSelectedFiles({ ...selectedFiles, offerDocs: updatedOfferDocs });
    } else {
      let updatedPropDocs = selectedFiles?.propertyDocs?.filter((el) => el?.propertyDocId === fileId)?.length ? selectedFiles?.propertyDocs?.filter((el) => el?.propertyDocId !== fileId) : [...selectedFiles?.propertyDocs, { propertyDocId: fileId, selectedParentId: null }];
      setSelectedFiles({ ...selectedFiles, propertyDocs: updatedPropDocs });
    }
  };

  return (
    <>
      <tr className={styles1.tableData} key={ele?._id} draggable onDragStart={(e) => handleDragStart(e, ele)} style={{border: "1px solid #bfbfbf"}}>
        <td
         onClick={() => handlePropertyDocs(ele)}
          style={{
            fontWeight: "bolder",
            color: "blue",
            minWidth: "250px",
            width: "65%",
            cursor: "pointer",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: isSmallScreen ? "13px" : "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ width: "26px", height: "26px" }} onMouseEnter={() => setHoveredRow(ele?._id)} onMouseLeave={() => setHoveredRow(null)}>
                {hoveredRow === ele?._id || selectedFiles?.propertyDocs?.filter((el) => el?.propertyDocId === ele?._id)?.length || selectedFiles?.offerDocs?.filter((el) => el?.offerDocId === ele?._id)?.length || selectedFiles?.resureSignDocs?.filter((el) => el?.resureSignDocId === ele?._id)?.length ? (
                  <Checkbox
                    checked={ele?.contractId ? selectedFiles?.offerDocs?.filter((el) => el?.offerDocId === ele?._id)?.length : ele?.isResureSignDoc ? selectedFiles?.resureSignDocs?.filter((el) => el?.resureSignDocId === ele?._id).length : selectedFiles?.propertyDocs?.filter((el) => el?.propertyDocId === ele?._id)?.length}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectFile(ele?._id, ele?.contractId ? true : false,ele?.isResureSignDoc ? true : false);
                    }}
                    style={{ marginRight: "4px" }}
                  />
                ) : (
                  <>
                    {ele.fileType === "IMAGE" ? (
                      <FileImageOutlined
                        style={{
                          color: "#ecd540",
                          marginTop: "5px",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    ) : ele.fileType === "PDF" || ele.isPdf || ele.pdfLink ? (
                      <FaRegFilePdf
                        style={{
                          color: "red",
                          marginTop: "5px",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    ) : ele.offerDocument && ele.contractType === "LCAES" ? (
                      <FileTextOutlined
                        style={{
                          color: "#74b3ed",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    ) : (
                      <FileTextOutlined
                        style={{
                          color: "#74b3ed",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <ContractTypeBadge contractType={ele?.contractType} additionalStyle={{ fontSize: "12px" }} />
              {ele?.isResureSignDoc && (
                <Tooltip title="RE-Sure Sign Document">
                  <Image
                    style={{
                      objectFit: "contain",
                      height: "40px",
                      verticalAlign: "middle",
                      marginLeft: "5px",
                      marginRight: "-5px",
                    }}
                    height={40}
                    src={ResureSign}
                    preview={false}
                  ></Image>
                </Tooltip>
              )}
              <span style={ellispesStyle}>
                <Tooltip title={ele?.updatedName ? ele.updatedName.trim() : formatBaseName(ele)}>
                  <span style={{ color: "blue" }}>{ele?.updatedName ? ele.updatedName.trim() : formatBaseName(ele)}</span>
                </Tooltip>
                {ele?.updatedName && (
                  <>
                    <br />
                    <Tooltip title={ele?.offerDocument || ele?.isCustomerDoc ? ele?.documentName : ele?.fileName}>
                      <span
                        style={{
                          fontSize: isSmallScreen ? "11px" : "14px",
                          color: "grey",
                        }}
                      >
                        ({ele?.offerDocument || ele?.isCustomerDoc ? ele?.documentName : ele?.fileName})
                      </span>
                    </Tooltip>
                  </>
                )}

                {/* "Without Buyers" label conditionally shown */}
                {ele?.offerDocument && !ele?.offerId && ![...listingContractTypes, "LCAES"].includes(ele?.contractType) && <span style={{ color: "grey", fontSize: "12px" }}>{" (Without Buyers)"}</span>}
              </span>
            </div>
            {ele?.transactionData && (
              <div
                style={{
                  color: "grey",
                  fontSize: "11px",
                  marginLeft: "24px",
                }}
              >
                {listingContractTypes.includes(ele.contractType) && ele.transactionData && ele.transactionData.ListingPeriodBeginDate && <span>{moment(ele.transactionData.ListingPeriodBeginDate).format("MM/DD/YYYY")}</span>}
                {listingContractTypes.includes(ele.contractType) && ele.transactionData && ele.transactionData.ListingPeriodEndByDate && <> - {moment(ele.transactionData.ListingPeriodEndByDate).format("MM/DD/YYYY")}</>}
              </div>
            )}
            <div
              style={{
                color: "grey",
                fontSize: "11px",
                marginLeft: "20px",
              }}
            >
              {ele.fileType ? `Uploaded by: ${ele.personId?.fullName}` : ""}
            </div>
          </div>
        </td>

        <td
          style={{
            color: "black",
            fontWeight: "500",
            textAlign: "center",
            minWidth: "50px",
            width: "10%",
            whiteSpace: "pre-wrap",
            border: "none",
          }}
        >
          <div>{moment(ele.createdDateMili).format("MM/DD/YYYY")}</div>
          <div>{moment(ele.createdDateMili).format("hh:mm A")}</div>
        </td>
        <td
          style={{
            textAlign: "center",
            minWidth: "100px",
            width: "15%",
            border: "none",
          }}
        >
          {(ele?.offerId && ele?.offerDocument && ele?.contractId && ![...listingContractTypes, "NET_SHEET"].includes(ele?.contractType) || ele?.isResureSignDoc) && (
            <Checkbox
              checked={ele?.isCreatedInRtd}
              onChange={(e) => handleToggleDashboard(ele, e.target.checked)}
              disabled={(ele?.isCreatedInRtd && createOfferContractTypes?.includes(ele?.contractType) && item?.status === "ACCEPTED") || (item?.isProperty && conterOfferContractTypes?.includes(ele?.contractType) && item?.propertyStatus !== "ACCEPTED")}
              style={{
                color: "black",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            />
          )}
           {!ele?.contractId && !ele?.isResureSignDoc&&
            (role === "SELLER" && item?.offerId ? (
              <Checkbox
                checked={ele?.isShared}
                onChange={(e) => {
                  handleShareUnshareFileConfirm(ele, e.target.checked);
                }}
                style={{
                  color: ele.isShared ? "white" : "black",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            ) 
            : role === "BUYER" && ele?.showSeller ? (
              <Checkbox
                checked={ele?.isShared}
                onChange={(e) => {
                  handleShareUnshareFileConfirm(ele, e.target.checked);
                }}
                style={{
                  color: ele?.isShared ? "white" : "black",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <Tooltip title={role === "SELLER" && !item?.offerId ? "Cannot share: Accepted offer does not exist." : role === "BUYER" && !ele?.showSeller ? "Please send this offer to seller agent to enable sharing." : ""} placement="right" style={{ width: "50px" }}>
                <Checkbox
                  checked={false}
                  disabled={true}
                  style={{
                    color: "black",
                    borderRadius: "5px",
                    cursor: "not-allowed",
                  }}
                />
              </Tooltip>
            )
            )}
        </td>

        <td
          style={{
            textAlign: "center",
            minWidth: "70px",
            width: "10%",
            color: "#085191",
            border: "none",
          }}
        >
          {hasPropertyDocsMenuItems({ eachDoc: ele, getCoordinateItem: item }) ? (
            <Dropdown overlay={<ProperyDocMenuItem parentDoc={ele} eachDoc={ele} getCoordinateItem={item} handleCreateAmendExtend={handleCreateAmendExtend} handleDeletePropertyDocs={handleDeletePropertyDocs} handleEditName={handleEditName} />} trigger={["hover", "click"]}>
              <MoreOutlined
                key="ellipsis"
                style={{
                  fontSize: "26px",
                  color: "#08c",
                  marginRight: "-15px",
                  paddingTop: "5px",
                }}
              />
            </Dropdown>
          ) : (
            <div />
          )}
        </td>
      </tr>

      <tr className={styles1.tableData} style={{ border: "1px solid #d3d3d3", height: 0 }}>
        <td colSpan={5} style={{ border: "1px solid #d3d3d3", margin: 0, padding: 0 }}></td>
      </tr>
      {ele?.matchedDocuments?.map((matchedDoc) => (
        <>
          <tr className={styles1.tableData} key={matchedDoc?._id} style={{ borderTop: "1px solid #c2c2c2", borderLeft: "none", borderRight: "none", border: "1px solid #bfbfbf" }}>
            <td
              style={{
                fontWeight: "bolder",
                color: "blue",
                minWidth: "250px",
                width: "65%",
                cursor: "pointer",
                paddingLeft: `${23}px`,
                border: "none",
              }}
              onClick={() => handlePropertyDocs(matchedDoc)}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <FileTextOutlined
                  style={{
                    color: "#74b3ed",
                    marginRight: "5px",
                    fontSize: "18px",
                  }}
                />
            <span style={ellispesStyle}>
                  <Tooltip title={matchedDoc?.updatedName ? matchedDoc.updatedName.trim() : formatBaseName(matchedDoc)}>
                    <span style={{ color: "blue" }}>{matchedDoc?.updatedName ? matchedDoc.updatedName.trim() : formatBaseName(matchedDoc)}</span>
                  </Tooltip>
                  {matchedDoc?.updatedName && (
                    <>
                      <br />
                      <Tooltip title={matchedDoc?.documentName || matchedDoc?.fileName}>
                        <span
                          style={{
                            fontSize: isSmallScreen ? "11px" : "14px",
                            color: "grey",
                          }}
                        >
                          ({matchedDoc?.documentName || matchedDoc?.fileName})
                        </span>
                      </Tooltip>
                    </>
                  )}
                </span>
              </div>
              {matchedDoc.transactionData?.ListingPeriodEndByDate && (
                <div
                  style={{
                    color: "grey",
                    fontSize: "11px",
                    marginLeft: "5px",
                  }}
                >
                  <span style={{ marginLeft: "19px" }}>
                    {<span>Ending Date </span>}
                    {<span> - {moment(matchedDoc.transactionData.ListingPeriodEndByDate).format("MM/DD/YYYY")}</span>}
                  </span>
                </div>
              )}
            </td>

            <td style={{ color: "black", fontWeight: "500", textAlign: "center", minWidth: "50px", width: "170px", whiteSpace: "nowrap", border: "none" }}>
              <div>{moment(matchedDoc?.createdDateMili).format("MM/DD/YYYY")}</div>
              <div>{moment(matchedDoc?.createdDateMili).format("hh:mm A")}</div>
            </td>
            <td style={{ textAlign: "center", minWidth: "70px", width: "10%", border: "none" }}>
              <div></div>
            </td>
            <td
              style={{
                textAlign: "center",
                minWidth: "100px",
                width: "15%",
                border: "none",
              }}
            >
              <div></div>
            </td>
            <td style={{ textAlign: "center", minWidth: "70px", width: "10%", border: "none" }}>
            {hasPropertyDocsMenuItems({eachDoc:matchedDoc, getCoordinateItem:item }) ? (
                <Dropdown overlay={<ProperyDocMenuItem parentDoc={ele} eachDoc={matchedDoc} getCoordinateItem={item} handleCreateAmendExtend={handleCreateAmendExtend} handleDeletePropertyDocs={handleDeletePropertyDocs} handleEditName={handleEditName} />} trigger={["hover", "click"]}>
                  <MoreOutlined
                    key="ellipsis"
                    style={{
                      fontSize: "26px",
                      color: "#08c",
                      marginRight: "-15px",
                      paddingTop: "5px",
                    }}
                  />
                </Dropdown>
              ) : (
                <div />
              )}
            </td>
          </tr>
        </>
      ))}
    </>
  );
};

export default PropertyDocFile;
